import { render, staticRenderFns } from "./ContratoTipoForm.vue?vue&type=template&id=ea709fe4&"
import script from "./ContratoTipoForm.vue?vue&type=script&lang=js&"
export * from "./ContratoTipoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports